import React, { Component } from 'react'
import Translations from '../../../TranslationsWrapper'
import FilterItem from './FilterItem'

class Filter extends Component {
  constructor(props) {
    super(props)

    // Bind events
    this.handleClick = this.handleClick.bind(this)

    // Default state
    this.state = {
      showFilterItems: false,
      options: this.props.officeTypes
    }
  }

  handleClick(e) {
    this.setState({ showFilterItems: !this.state.showFilterItems })
  }

  render() {
    const filterIsOpenIcon = this.state.showFilterItems
      ? 'u-icon-arrow-up c-location-finder__filter__header__icon--active'
      : 'u-icon-arrow-down'

    return (
      <div className="c-location-finder__filter">
        <div
          className="c-location-finder__filter__header"
          onClick={this.handleClick}
        >
          {this.props.translations.Filter.Title}{' '}
          <i
            className={`${filterIsOpenIcon} c-location-finder__filter__header__icon`}
          />
        </div>

        {this.state.showFilterItems && (
          <div className="c-location-finder__filter__items">
            {this.state.options.map((option, index) => {
              return (
                <FilterItem
                  key={index}
                  value={option.Id}
                  name={option.Name}
                  icon={option.Icon}
                  isSelected={option.IsSelected}
                />
              )
            })}
          </div>
        )}
      </div>
    )
  }
}

export default Translations('js-location-finder')(Filter)
